/**
 * Created by pandemio on 3/4/19.
 */
import React from 'react';
import { Container, Col,  Row, } from 'reactstrap';
/** Multiple Language imports **/
import { withLocalize } from "react-localize-redux";
import { renderToStaticMarkup } from 'react-dom/server'; // Fix by the author. Do not remove even if it's not resolved
import global from "../translations/global.json";
import { Translate } from "react-localize-redux";
/** End of Multiple Language imports **/
import LanguageManager from '../custom-classes/language-manager';
import Footer from './footer/footer';
import NavbarDesktop from './navbar/navbar-desktop-top';
import NavbarMobile from './navbar/navbar-mobile';
import 'react-dates/initialize';
import 'react-dates/lib/css/_datepicker.css';
import PlatformDownloadList from './item-list/platform-download-list';
import { Link } from "react-router-dom";

/**
 * The component (window) to download the app for the first time
 */
class DownloadFirstTime extends React.Component{

    constructor(props){
        // Super is always called when defining the constructor of a subclass
        // All React component classes that have a constructor, should start it with a super(props) call.
        super(props);
        // To support language library add the following lines
        this.props.initialize({
            languages: [
                { name: "English", code: "en" },
                { name: "Español", code: "es" }
            ],
            options: { renderToStaticMarkup, defaultLanguage: LanguageManager.getLanguage() }
        });
        this.props.addTranslation(global);

        this.state = {
            subscriptionId: props.location.subscriptionId,
            mobile: false,
            didMount: false,
            loading: false,
            showErrorModal: false,
        };
    }

    componentDidMount() {
        window.addEventListener("resize", this.resize.bind(this));
        this.resize();
        this.setState({didMount: true},()=>{

        });
    }

    /**
     * To evaluate when the screen size changed
     */
    resize() {
        this.setState({mobile: window.screen.width <= 1024});
    }


    /**
     * Renders the landing page
     * @returns {XML}
     */
    render()
    {
        return (
            <div>
                {this.state.mobile ? <NavbarMobile/> : <NavbarDesktop/>}
                <div className="container-padding card-white">
                    <Container className="margin-top-mandatory-60">
                        <Row className="centered-text">
                            <Col xs={{size: 12}} sm={{size: 12}} md={{size: 12}} lg={{size: 12}}>
                                <h1 className="font-now-bold">
                                    <Translate id="downloads.download-app-for-your-child"/>
                                </h1>
                            </Col>
                        </Row>
                        <Row>
                            <PlatformDownloadList/>
                        </Row>
                        <Row>
                            <Col xs={{size: 12}} sm={{size: 12}} md={{size: 12}} lg={{size: 12}}>
                                <h2 className="font-now-bold">
                                    <Translate id="downloads.are-ready-downloaded-the-app"/>
                                </h2>
                                <br/>
                                <h3>
                                    <Translate id="downloads.to-see-progress"/> {' '}
                                    <Link className="btn btn-warning" to="/dashboard">
                                        <Translate id="downloads.here"/>
                                    </Link>
                                </h3>
                            </Col>
                        </Row>
                    </Container>
                </div>
                <Footer/>
            </div>
        )
    }
}

export default withLocalize(DownloadFirstTime);